import { DOMESTIC_INSURANCE_FORM } from '../../../actions/domesticInsurance/quote';
import { quoteFormValidation } from './quote';

import { DOMESTIC_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE } from '../../../actions/domesticInsurance/personalDetails';
import { personalDetailsValidation } from './personalDetails';

import { BUILDING_DETAILS_FORM_SET_VALUE } from '../../../actions/domesticInsurance/buildingDetails';
import { buildingDetailsValidation } from './buildingDetails ';
import { MOTOR_INSURANCE_CAR_DETAILS_FORM_SET_VALUE } from '../../../actions/domesticInsurance/carDetails';
import { carDetailsValidation } from './carsDetails';

import { MOTOR_INSURANCE_AGENT_MODAL_DETAILS_SET_VALUE } from '../../../actions/domesticInsurance/motorAgentModal';
import { agentModalFormValidation } from './travelAgentModal';

import { DOMESTIC_INSURANCE_DOCUMENTS_FORM_SET_VALUE } from '../../../actions/domesticInsurance/Documents';
import { documentsUploadValidation } from './documents';
import { MOTOR_INSURANCE_DECLARATIONS_FORM_SET_VALUE } from '../../../actions/domesticInsurance/declarations';
import { declarationsFormValidation } from './declarations';

import { MOTOR_INSURANCE_NEXT_OF_KIN_FORM_SET_VALUE } from '../../../actions/domesticInsurance/nextOfKin';
import { nextOfKinValidation } from './nextOfKin';

import { PAYMENTS_SET_VALUE } from '../../../actions/domesticInsurance/payments';
import { paymentsFormValidation } from './payments';

import { SET_SHARE_EMAIL_VALUE } from '../../../actions/domesticInsurance/quote';
import { shareQuoteValidation } from './shareQuote';

export const domesticInsuranceValidation = (store, next, action) => {
     if (action.type.startsWith(DOMESTIC_INSURANCE_DOCUMENTS_FORM_SET_VALUE)) {
        return documentsUploadValidation(store, next, action);
    }
    if (action.type.startsWith(DOMESTIC_INSURANCE_FORM)) {
        return quoteFormValidation(store, next, action);
    }
    if (action.type.startsWith(DOMESTIC_INSURANCE_PERSONAL_DETAILS_FORM_SET_VALUE)) {
        return personalDetailsValidation(store, next, action);
    }
    if (action.type.startsWith(BUILDING_DETAILS_FORM_SET_VALUE)) {
        return buildingDetailsValidation(store, next, action);
    }
    if (action.type.startsWith(PAYMENTS_SET_VALUE)) {
        return paymentsFormValidation(store, next, action);
    }
    if (action.type.startsWith(MOTOR_INSURANCE_NEXT_OF_KIN_FORM_SET_VALUE)) {
        return nextOfKinValidation(store, next, action);
    }
    if (action.type.startsWith(MOTOR_INSURANCE_DECLARATIONS_FORM_SET_VALUE)) {
        return declarationsFormValidation(store, next, action);
    }
    if (action.type.startsWith(SET_SHARE_EMAIL_VALUE)) {
        return shareQuoteValidation(store, next, action);
    }
    if (action.type.startsWith(MOTOR_INSURANCE_CAR_DETAILS_FORM_SET_VALUE)) {
        return carDetailsValidation(store, next, action);
    }
    if (action.type.startsWith(MOTOR_INSURANCE_AGENT_MODAL_DETAILS_SET_VALUE))
        return agentModalFormValidation(store, next, action);
   

    return null;
};
